const dateElement = document.querySelector( '[data-rss-date]' );
const rssInner = document.querySelector( '[data-rss-article]' );

if ( isHomePage || isInvestorsPage ) {

	const url = 'https://www.globenewswire.com/SubscribeToRss/z-liGoWczerazHOJ-tTZCA%3d%3d';
	const outsourcedUrlProxy = 'https://cleantechnica.com/wp-json/wp/v2/posts';
	const outsourcedUrl = `/app/themes/Volum8WP/assets/functions/inc/CORS_Proxy.php?url=${outsourcedUrlProxy}`;
	const rssUrl = `/app/themes/Volum8WP/assets/functions/inc/CORS_Proxy.php?url=${url}`;

	fetch( rssUrl )
		.then( response => response.json() )
		.then( data => {

			/**
			 * Because we return the response with headers, we modify the string to
			 * remove the headers so that we can parse the string as XML.
			 */
			const xmlData = data.contents.substring( data.contents.indexOf( '<?xml version' ) );
			const contents = new window.DOMParser().parseFromString( xmlData, 'text/xml' );

			// console.log( contents );

			const items = contents.querySelectorAll( 'item' );
			console.log( 'items', items );

			const articles = [];
			const articlesList = document.querySelector( '[data-rss-posts]' );

			for ( i = 0; i <= 3; i++ ) {
				const article = {};
				article.description = items[i].querySelector( 'description' ).innerHTML;
				article.latest = items[i].querySelector( 'title' ).innerHTML;
				article.date = items[i].querySelector( 'pubDate' ).innerHTML;
				article.link = items[i].querySelector( 'link' ).innerHTML;

				if ( ! isInvestorsPage && i === 3 ) {
					continue;
				}

				if ( article.latest && article.date && article.link ) {

					articlesList.classList.remove( 'dn' );
					articlesList.classList.add( 'flex' );

					const isFeaturedArticle = isInvestorsPage && i === 0;

					const articleListItem = document.createElement( 'li' );
					const articleDescription = document.createElement( 'div' );
					articleDescription.classList.add( 'body-copy', 'entry-content', 'lh-copy', 'mb3' );

					if ( isFeaturedArticle ) {

						articleListItem.classList.add( 'w-100', 'bb', 'b--black-20', 'pb3', 'pb4-ns' );

						// Remove CDATA tags from content.
						const articleClean = article.description.substring( 9 );
						const articleCleanEnd = articleClean.substring( 0, articleClean.length - 3 );

						articleDescription.innerHTML = articleCleanEnd;

						// Remove 'justify' align attribute value if it exists.
						const lead = articleDescription.querySelector( 'p' );
						if ( lead ) {
							lead.removeAttribute( 'align' );
						}

					} else {
						articleListItem.classList.add( 'post', 'w-100', 'w-third-ns', 'pa3', 'pv4-l' );
						if ( isHomePage ) {
							articleListItem.classList.add( 'ph4-l' );
						}
					}

					const articleInner = document.createElement( 'article' );

					if ( isFeaturedArticle ) {
						articleInner.classList.add( 'pr5-l', 'mw6', 'mw7-l', 'ph3' );
					}

					const articleHeader = document.createElement( 'h2' );
					if ( isFeaturedArticle ) {
						articleHeader.classList.add( 'page-title', 'lh-title', 'fw9', 'f3', 'f2-l', 'mt0', 'mb3' );
					} else {
						articleHeader.classList.add( 'page-title', 'lh-title', 'fw9-ns', 'f4', 'f3-l', 'mt0', 'mb3', 'pr4-l' );
					}

					articleHeader.innerHTML = article.latest;

					const articleDate = document.createElement( 'time' );
					articleDate.classList.add( 'db', 'fw9', 'tracked', 'f6', 'mt0', 'mb2' );
					const articleDateObject = new Date( article.date );
					const month = articleDateObject.toLocaleString( 'default', { month: 'long' } );
					const formatDate = `${month} ${articleDateObject.getDate()}, ${articleDateObject.getFullYear()}`;
					articleDate.textContent = formatDate;

					const articleLink = document.createElement( 'a' );
					articleLink.classList.add( 'bg-blue', 'hover-bg-white', 'ba', 'hover-b--blue', 'hover-blue', 'bw1', 'b--white', 'white', 'pv2', 'ph4', 'ph5-l', 'br4', 'f6', 'fw6', 'dib', 'no-underline' );
					articleLink.href = article.link;
					articleLink.target = '_blank';
					articleLink.textContent = 'Read more';

					articleListItem.appendChild( articleInner );
					articleInner.appendChild( articleDate );
					articleInner.appendChild( articleHeader );
					if ( isFeaturedArticle ) {
						articleInner.appendChild( articleDescription );
					}
					articleInner.appendChild( articleLink );

					articlesList.appendChild( articleListItem );

				}

			}

			console.log( articles );

			const item = contents.querySelector( 'item' );
			const latest = item.querySelector( 'title' ).innerHTML;
			const date = item.querySelector( 'pubDate' ).innerHTML;
			const link = item.querySelector( 'link' ).innerHTML;

		} );

	fetch( outsourcedUrl )
		.then( response => response.json() )
		.then( data => {
			const latest = data.contents[0].title.rendered;
			const link = data.contents[0].link;
			const date = data.contents[0].date;
			if ( latest && link ) {
				const html = `<a class="white no-underline underline-hover"
					href="${link}" target="_blank" rel="noreferrer">${latest}</a>`;
				rssInner.innerHTML = html;
			}
			if ( date ) {
				const articleDate = new Date( date );
				const formatDate = `${articleDate.getMonth() + 1}/${articleDate.getDate()}`;
				dateElement.textContent = formatDate;
			}

			safeExternalLinks();

		} );
}
